import { components } from 'react-select';
import { useEffect, useRef, useState } from 'react';

const CustomSingleValue = (props) => {
  const textRef = useRef(null);
  const wrapperRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);

  useEffect(() => {
    const textEl = textRef.current;
    const wrapperEl = wrapperRef.current;

    if (textEl && wrapperEl) {
      const isOverflowing =
        textEl.scrollWidth > wrapperEl.clientWidth;

      setShouldScroll(isOverflowing);
    }
  }, [props.children]);

  return (
    <components.SingleValue {...props}>
      <div ref={wrapperRef} className="scroll-text-wrapper">
        <div
          ref={textRef}
          className={`scroll-text ${shouldScroll ? 'animate-scroll' : ''}`}
        >
          {props.children}
        </div>
      </div>
    </components.SingleValue>
  );
};

export default CustomSingleValue;